import React from 'react';
import { string } from 'prop-types';
import Logo from './logo.svg';


function NavbarLogo({ className }) {
  return <img className={className} src={Logo} alt="Logo Olx" />;
}

NavbarLogo.propTypes = {
  className: string.isRequired,
};

export default NavbarLogo;
